import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import useAppState from "../../hooks/useAppState";
import { AppConfig } from "../../utils/config";
import { cleanHtmlString } from "../../utils/constants";
import type { Product } from "../Home/Home";
import styles from "./Review.module.css";

export default function Review() {
  const { shoppingCart, setShoppingCart } = useAppState();

  const subtotal = (shoppingCart as Product[]).reduce(
    (acc: number, val: Product) => acc + val.Price,
    0
  );

  function removeFromBasket(data: Product) {
    const newCart = shoppingCart.filter((a) => a.ID !== data.ID);
    setShoppingCart(newCart);
  }

  return (
    <>
      <Helmet>
        <title>Review | Martin Townsend Postal History</title>
        <meta
          name="description"
          content="Review your selected postal history items and complete your purchase. Secure checkout with worldwide shipping available."
        />
      </Helmet>
      <div className={styles.reviewContainer}>
        <h1 className={styles.heading}>Review Your Order</h1>

        {shoppingCart.length === 0 ? (
          <div className={styles.emptyCart}>
            <h2>Your cart is empty</h2>
            <p>Looking for something special?</p>
            <Link to="/">
              <Button variant="contained" disableElevation>
                Browse Items
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.items}>
              {shoppingCart.map((item) => (
                <div key={item.ID} className={styles.item}>
                  <div className={styles.itemDescription}>
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`/item/${item.ID}`}
                      tabIndex={-1}
                    >
                      <img
                        src={`${AppConfig.smImgUrl}/${item.ID}.jpg`}
                        alt={`${item.ID} item`}
                      />
                    </Link>
                    <br />
                    <Link
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        fontFamily: "Book Antiqua",
                      }}
                      to={`/item/${item.ID}`}
                      tabIndex={-1}
                      dangerouslySetInnerHTML={{
                        __html: cleanHtmlString(item.Title).replace(
                          /\\r\\n/g,
                          "\n"
                        ),
                      }}
                    />
                  </div>
                  <div className={styles.itemBuyZone}>
                    <div className={styles.price}>£{item.Price}</div>
                    <Button
                      onClick={() => removeFromBasket(item)}
                      size="small"
                      variant="outlined"
                      disableElevation
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.summary}>
              <div className={styles.summaryRow}>
                <span>
                  Subtotal ({shoppingCart.length} item
                  {shoppingCart.length !== 1 ? "s" : ""}):
                </span>
                <span className={styles.summaryPrice}>
                  £{subtotal.toFixed(2)}
                </span>
              </div>
              <p className={styles.shippingNote}>
                Shipping calculated at checkout
              </p>
              <Link to="/cart" className={styles.checkoutLink}>
                <Button
                  variant="contained"
                  disableElevation
                  fullWidth
                  size="large"
                >
                  Continue to Payment
                </Button>
              </Link>
              <Link to="/" className={styles.continueShoppingLink}>
                Continue Shopping
              </Link>
            </div>
          </>
        )}
      </div>
    </>
  );
}
